import {alias, createModelSchema, custom, deserialize, SKIP} from "serializr";
import { Schema } from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {BaseObject} from "@/common/BaseObject";

export class ItemGroupModel extends BaseObject {
    constructor(
      key = "",
      code = null,
      priority = null
    ) {
        super();

        this._key = key;
        this._code = code;
        this._priority = priority;
    }

    static schema() {
        return custom(
          (v) => {
              return v && v.key ? v.key : SKIP;
          },

          v => {
              if (typeof v === 'string') {
                  return RedactorUtils.getItemGroupByKey(v);
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(ItemGroupModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static schemaByCode() {
        return custom(
          (v) => {
              return (v && Number.isInteger(v.code)) ? v.code : SKIP;
          },

          v => {
              if (typeof v === 'number') {
                  return RedactorUtils.getItemGroups().find(i => i.code === v) || null;
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(ItemGroupModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static isNone(value) {
        return (
          value instanceof ItemGroupModel &&
          (value.code === 0 || value.key === "none")
        );
    }

    static getNone(items) {
        return items.find(
          item => item && (item.code === 0 || item.key === "none")
        ) || null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    valid() {
        if (typeof this.key !== "string" || !this.key.trim()) {
            return false;
        }

        if (!Number.isInteger(this.code) || this.code < 0)  {
            return false;
        }

        if (!Number.isInteger(this.priority) || this.priority < 0)  {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemGroupModel());
        } else if (target instanceof ItemGroupModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemGroupModel, {
    _key: alias("key", Schema.primitive()),
    _code: alias("code", Schema.number()),
    _priority: alias("priority", Schema.number())
});
